<template>
  <div class="ad-details">
    <heads></heads>

    <p class="content" v-if="message" v-html="message.description"></p>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import axios from "axios";

export default {
  name:"adDetails",
  components: {
    heads
  },
  props: {},
  data() {
    return {
      id: null,
      message: null
    };
  },
  watch: {},
  computed: {
   getScrolltop() {
      let _this = this;
      window.addEventListener("scroll", () => {
        _this.top =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset;
      });
      return _this.top > 300;
    }
  },
  methods: {
    requestMessage(id){
      axios
        .get(`/mobile/ad/getad.jhtml`, {
          params: {
            id
          }
        })
        .then(res => {
          if(res.data.success){
            this.message = res.data.output;
          }
        });
    }
  },
  created() {

  },
  mounted() {
    this.id = this.$route.query.id;
    this.requestMessage(this.id);
  }
};
</script>
<style scoped>
.ad-details .content{
  width: 80%;
  margin: 0 auto;
  padding-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/adDetails.vue